import Empty from 'constants/empty';

const cmsRMNBannerSelector = store => store.rmnBanners || Empty.Object;

export { cmsRMNBannerSelector };
